import { render, staticRenderFns } from "./FilterAllocation.vue?vue&type=template&id=77af8fe6"
import script from "./FilterAllocation.vue?vue&type=script&lang=js"
export * from "./FilterAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports